module.exports = __webpack_public_path__ + "img/not-found.d21eebfa.png";